<template>
  <div class="sq-footer">
    <span v-if="this.language == 'EN'">Geospace &copy; 2018</span>
    <span v-if="this.language == 'PT'">Geospace &copy; 2018</span>
  </div>
</template>

<style scoped>
  .sq-footer {
    background-color: #455A64;
    height: 20px;
    font-size: 11px;
    display: flex;
    justify-content: flex-end;
    color: white;
    align-items: center;
    padding-right: 1em;
  }
  a {
    color:white;
  }
</style>

<script>
import { mapGetters, mapState } from 'vuex'
import { LANGUAGE } from '../../store/actions/navigation'

  export default {
    name: 'personalized-footer',
    components: {
    },
    computed: {
      ...mapGetters(['degreeKind', 'messageShow', 'getProfile', 'isAuthenticated', 'isProfileLoaded', 'janelaLateral','getLanguage']),
      ...mapState({
        language: state => state.navigation.language,
        messagesTotal: state => state.messages.userMessagesTotal,
        messageShow: state => state.messages.messageShow,
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.title} ${state.user.profile.name}`,
      }),
    },
    data () {
      return {
        dialog: false,
        widgets: false,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/footer/index.vue